module.exports = __webpack_public_path__ + "b047fc8e25a874bece3e3c5234de05af.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-100.woff2
// module id = 452
// module chunks = 0